
import React from "react";
import ScrollAnimation from "react-animate-on-scroll";

import "animate.css";

const EventThemesBase = () => {
    const themes = [
        {
            title: "Як знайти своїх: гроші, партнери, можливості",
            desc: (
                <>
                    Як перетворити велику ідею на новий проєкт, знайти людей, які готові повірити в неї, і залучити необхідні ресурси? Незалежно від того, чи йдеться про бізнес, соціальну ініціативу або проєкт в іншій сфері, успіх залежить від здатності об’єднувати людей, знаходити партнерів і перетворювати ідеї на реальні зміни.
                    Це розмова про <strong>підприємницьке мислення, переговори, довіру інвесторів і партнерів, фінансові та репутаційні ризики, роботу у партнерстві, відповідальність за команду й людей,</strong> які залежать від твоїх рішень. 
                    Як братися за більше, коли ставки високі, а готових рецептів немає? 

                </>
            ),
        },
        {
            title: "Сміливість вийти зі своєї «бульбашки»",
            desc: (
                <>
                    Що відбувається, коли ти опиняєшся в абсолютно новій для себе індустрії? Як наважитися зайти туди, де немає готового досвіду, навчатися на ходу, брати на себе нову відповідальність і поступово знаходити себе в іншій ролі? Що допомагає наважуватися на професійні трансформації, розвивати нові компетенції, змінювати мислення та долати внутрішні барʼєри?
                    Поговоримо зі спікерками, які <strong>вийшли зі своєї професійної бульбашки</strong> та <strong>відкрили для себе нові сфери, можливості й масштаби.</strong>
                </>
            ),
        },
        {
            title: "ШІ for She – нова суперсила чи нова залежність? ",
            desc: (
                <>
                    Як перетворити ШІ на особистого помічника, який економить час, допомагає працювати ефективніше, швидше навчатися та знаходити нові рішення? Розберемося, <strong>як використовувати ШІ в роботі, навчанні і повсякденному житті</strong>, де він справді розширює наші можливості, а де варто зупинитися й не передавати технологіям власне мислення та рішення.
                </>
            ),
        },
        {
            title: "Персональна фінансова подушка: важливо вже сьогодні чи подумаю завтра?",
            desc: (
                <>
                    Як створити власну фінансову опору, не залежати від одного джерела доходу та бути готовою до непередбачуваних змін. Говоримо про <strong>накопичення, інвестиції, власний капітал, фінансову безпеку, спільний бюджет чи гроші у парі.</strong>
                </>
            ),
        },
        {
            title: "Хто обирає наш одяг: ми, тренди чи алгоритми?",
            desc: (
                <>
                    Чи стали ми по-іншому обирати одяг і beauty-продукти? Хто насправді впливає на наш вибір — власні вподобання, тренди, соціальні мережі чи алгоритми? <strong>Як технології змінюють досвід у fashion та beauty:</strong> від AI-стилістів і персональних рекомендацій до віртуальної примірки, аналізу гардероба та персоналізованого підбору косметики? Чи справді ми стали споживати свідоміше, як змінюються очікування жінок і як індустрії моди та краси адаптуються до нових звичок, цінностей і моделей споживання?
                </>
            ),
        },
        {
            title: "Власна професійна видимість та друга сторона публічності",
            desc: (
                <>
                    Як змінилася поведінка аудиторії та спосіб, у який ми споживаємо інформацію, обираємо, кому довіряти та за ким стежити? Як на це впливають креативність, власний стиль і вміння говорити про важливе по-своєму? Як одне публічне висловлювання може змінити ставлення аудиторії, де проходить межа між сміливістю та необережністю і хто відповідає за сказане в кадрі?
Подкасти, YouTube, соцмережі, колонки та інші формати — про те, як бути помітною в інформаційному шумі, відрізнятися від інших, формувати навколо себе власну аудиторію та <strong>перетворювати персональний бренд на професійний актив.</strong>
                </>
            ),
        },
        {
            title: "Longevity: тренд, який стає стилем життя",
            desc: (
                <>
                    Як змінюється культура турботи про себе і які індустрії формують цей тренд: <strong>фарма та медицина, жіноче і репродуктивне здоров’я, beauty, wellness, nutrition, sport, health-tech, wearable-пристрої.</strong> Що сьогодні допомагає жінкам довше залишатися активними, добре почуватися та підтримувати якість життя, і куди рухається ринок longevity.
                </>
            ),
        },
    ];

    const cardColors = [
        "bg-[#95C8BF]",
        "bg-[#F5D858]",
        "bg-[#486D97]",
        "bg-[#B43125]",
    ];

    return (
        <section className="mb-16 bg-white md:mb-32" id="themes">
            <div className="container mx-auto px-4 sm:px-0">
                <ScrollAnimation
                    animateIn="animate__fadeInUp"
                    animateOnce={true}
                >
                    <h2
                        className="mb-8 text-center text-3xl font-bold uppercase
                        text-[#245864] sm:text-4xl md:mb-12
                        lg:text-left lg:text-[60px] lg:leading-[1.1]"
                    >
                        Теми SHE CONGRESS 2026
                    </h2>
                </ScrollAnimation>

                <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-8">
                    {themes.map((theme, index) => (
                        <ScrollAnimation
                            key={theme.title}
                            animateIn="animate__fadeInUp"
                            animateOnce={true}
                            className={`h-full min-w-0 xl:col-span-2 ${
                                index === 4 ? "xl:col-start-2" : ""
                            } ${
                                index === 6
                                    ? "sm:col-span-2 sm:mx-auto sm:w-[calc(50%-0.75rem)] xl:col-span-2 xl:mx-0 xl:w-full"
                                    : ""
                            }`}
                        >
                            <article
                                className="flex h-full flex-col border
                                border-[#95C8BF]/50 bg-white
                                p-5 text-[#245864] md:p-6"
                            >
                                <div
                                    className={`mb-5 flex h-14 w-14 shrink-0
                                    items-center justify-center text-[30px]
                                    font-bold leading-none text-white
                                    ${cardColors[index % cardColors.length]}`}
                                >
                                    {String(index + 1).padStart(2, "0")}
                                </div>

                                <h3
                                    className="mb-4 text-[22px] font-bold
                                    leading-[1.25] md:text-[24px]"
                                >
                                    {theme.title}
                                </h3>

                                <div
                                    className="themes-description
                                    text-[16px] leading-[1.55]
                                    md:text-[18px] [&_strong]:font-semibold"
                                >
                                    {theme.desc}
                                </div>
                            </article>
                        </ScrollAnimation>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default EventThemesBase;
